module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('box-widget', {
    attrs: {
      "icon": "bullhorn"
    }
  }, [_c('template', {
    slot: "head"
  }, [_vm._v(_vm._s(_vm.$t('pos.customer.campaigns')))]), _c('template', {
    slot: "content"
  }, [_c('ul', {
    staticClass: "campaigns-list"
  }, [_vm._l((_vm.campaigns), function(campaign, key) {
    return [_c('li', {
      staticClass: "campaigns-list-item",
      class: {
        'campaigns-list-item--open': campaign.isOpen
      }
    }, [_c('div', {
      staticClass: "campaigns-item-breakline"
    }), _c('div', {
      staticClass: "campaigns-item-title",
      on: {
        "click": function($event) {
          _vm.onToggle(key)
        }
      }
    }, [_c('span', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-9"
    }, [_vm._v(_vm._s(campaign.name)), (campaign.date) ? _c('span', {
      staticClass: "ml-1"
    }, [_vm._v("(" + _vm._s(campaign.date) + ")")]) : _vm._e()]), _c('div', {
      staticClass: "col-3"
    }, [_c('div', {
      staticClass: "campaigns-item-icon"
    }, [_c('icon', {
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "name": campaign.isOpen ? 'angle-up' : 'angle-down',
        "scale": "1.5"
      }
    })], 1), _c('b-btn', {
      staticClass: "float-right mr-2",
      attrs: {
        "to": {
          name: "campaign",
          params: {
            code: campaign.code
          }
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pos.buttons.open')))])], 1)])])]), _c('div', {
      staticClass: "campaigns-item-content"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6 mt-2"
    }, [_c('h2', {
      staticClass: "box-widget-list-header"
    }, [_vm._v(_vm._s(_vm.$t('pos.customer.campaign.code')))]), _c('span', {
      staticClass: "box-widget-list-value"
    }, [_vm._v(_vm._s(campaign.code))])]), _c('div', {
      staticClass: "col-md-6 mt-2"
    }, [_c('h2', {
      staticClass: "box-widget-list-header"
    }, [_vm._v(_vm._s(_vm.$t('pos.customer.campaign.status')))]), _c('span', {
      staticClass: "box-widget-list-value"
    }, [_vm._v(_vm._s(_vm.$t(("terms.statuses." + (campaign.baseStatus.code)))))])]), _c('div', {
      staticClass: "col-md-6 mt-2"
    }, [_c('h2', {
      staticClass: "box-widget-list-header"
    }, [_vm._v(_vm._s(_vm.$t('pos.customer.campaign.model')))]), _c('span', {
      staticClass: "box-widget-list-value"
    }, [_vm._v(_vm._s(_vm.$t(("terms.modes." + (campaign.mode)))))])]), _c('div', {
      staticClass: "col-md-6 mt-2"
    }, [_c('h2', {
      staticClass: "box-widget-list-header"
    }, [_vm._v(_vm._s(_vm.$t('pos.customer.campaign.start-date')))]), _c('span', {
      staticClass: "box-widget-list-value"
    }, [_vm._v(_vm._s(campaign.date))])]), _c('div', {
      staticClass: "col-md-6 mt-2"
    }, [_c('h2', {
      staticClass: "box-widget-list-header"
    }, [_vm._v(_vm._s(_vm.$t('pos.customer.campaign.instance-number')))]), _c('span', {
      staticClass: "box-widget-list-value"
    }, [_vm._v(_vm._s(campaign.iterations.length))])]), _c('div', {
      staticClass: "col-md-6 mt-2"
    }, [_c('h2', {
      staticClass: "box-widget-list-header"
    }, [_vm._v(" " + _vm._s(_vm.$t('pos.customer.campaign.ad-format')))]), _c('span', {
      staticClass: "box-widget-list-value"
    }, [_vm._v(_vm._s(_vm.$t(("terms.format.name." + (campaign.type)))))])])]), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6 mt-3"
    }, [_c('h2', {
      staticClass: "box-widget-list-header"
    }, [_vm._v(_vm._s(_vm.$t('pos.customer.campaign.creatives')))])])]), _c('div', {
      staticClass: "row"
    }, [_vm._l((campaign.creatives), function(creative) {
      return [_c('div', {
        staticClass: "col-lg-12 mt-2 creative-section"
      }, [_c('creative-preview-scaled', {
        attrs: {
          "creative": creative,
          "facebookPage": campaign.fbpage
        }
      })], 1)]
    })], 2), _c('div', {
      staticClass: "mt-4"
    })])])]
  })], 2), _c('gotu-nav-button', {
    attrs: {
      "theme": "default-cta",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.buttons.load-more')))])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-edc81a88"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/customer/campaigns/Campaigns.vue
// module id = 2100
// module chunks = 1